export default __webpack_public_path__ + "static/screen_erp_6-5cf8503fb3ba3fb7339b9dfdd89950da.png";